import { generatePath } from 'react-router-dom';

export enum PathsMap {
  ANY = '*',
  INTRO = '/',
}

export const getIntroPath = () => generatePath(PathsMap.INTRO);
